import useAuthentication from "../../hooks/useAuthentication";
import { Navigate, Outlet } from "react-router-dom";
import useLocalStorage from "../../hooks/useLocalStorage";
import { PUBLIC_BASE } from "../../shared/lib/routesResolver";

const PrivateRoute = () => {
  const auth = useAuthentication();
  const storage = useLocalStorage();

  if (auth.tokenIsValid()) {
    return auth.isLogged() ? <Outlet /> : <Navigate to={PUBLIC_BASE} />;
  } else {
    storage.clear();
    return <Navigate to={PUBLIC_BASE} />;
  }
};

export default PrivateRoute;